export default function getKeysByValue(object, value) {
  const keys = Object.keys(object);

  return keys.filter((key) => object[key] === value);
}
